






import {Vue, Component, Prop} from "vue-property-decorator";

const DefaultColor = "#0000008a";

@Component
export default class PolygonIcon extends Vue {
    @Prop({default: "24px"})
    height!: string;

    @Prop({default: "24px"})
    width!: string;

    @Prop({default: DefaultColor})
    color!: string;
}
